import { api } from '../../client';

export interface PayrollSummaryDto {
  employees: number;
  monthly_payroll: number;
  next_pay_date: string | null;
  pending_reviews: number;
}

export interface PayrollRunDto {
  id: string;
  period_start: string;
  period_end: string;
  pay_date: string;
  status: string;
  total_gross_pay: number;
  total_deductions: number;
  total_net_pay: number;
  notes: string | null;
  created_at: string;
}

export interface PayrollEntryDto {
  id: string;
  employee_id: string;
  employee_name: string;
  gross_pay: number;
  total_deductions: number;
  net_pay: number;
  hours_worked: number | null;
  base_pay: number;
  taxes_deducted: number;
  benefits_deducted: number;
  other_deductions: number;
  bonuses: number;
  commissions: number;
}

export interface PayrollRunDetailDto extends PayrollRunDto {
  entries: PayrollEntryDto[];
}

export const hrPayrollApi = {
  async getSummaryAndRuns(): Promise<{
    data?: { summary: PayrollSummaryDto; runs: PayrollRunDto[] };
    message?: string;
  }> {
    return api.get('/hr/payroll') as Promise<{
      data: { summary: PayrollSummaryDto; runs: PayrollRunDto[] };
    }>;
  },

  async getRun(id: string): Promise<{ data?: PayrollRunDetailDto; message?: string }> {
    return api.get(`/hr/payroll/runs/${id}`) as Promise<{ data: PayrollRunDetailDto }>;
  },

  async runPayroll(data: {
    period_start: string;
    period_end: string;
    pay_date: string;
  }): Promise<{
    data?: PayrollRunDto;
    message?: string;
    errors?: Record<string, string[]>;
  }> {
    return api.post('/hr/payroll/runs', data) as Promise<{
      data: PayrollRunDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async updateRun(
    id: string,
    data: { status?: string; notes?: string }
  ): Promise<{ data?: PayrollRunDto; message?: string }> {
    return api.put(`/hr/payroll/runs/${id}`, data) as Promise<{ data: PayrollRunDto; message?: string }>;
  },
};
